/**
 * Orchestra AI Platform - Create Project Dialog
 * 
 * Dialog for creating new projects
 * 
 * @fileoverview Project creation form with validation
 */

import { useState } from 'react';
import PropTypes from 'prop-types';
import './Workspace.css';

/**
 * Create Project Dialog Component
 * @param {Object} props
 * @param {Function} props.onSave - Save handler
 * @param {Function} props.onCancel - Cancel handler
 */
export function CreateProjectDialog({ onSave, onCancel }) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [type, setType] = useState('workflow');

  /**
   * Handle save
   */
  const handleSave = () => {
    if (!name.trim()) {
      alert('Project name is required');
      return;
    }

    onSave({
      name: name.trim(),
      description: description.trim(),
      type,
    });
  };

  return (
    <div className="create-project-dialog-overlay">
      <div className="create-project-dialog">
        {/* Header */}
        <div className="dialog-header">
          <h2>Create New Project</h2>
        </div>

        {/* Content */}
        <div className="dialog-content">
          <div className="form-group">
            <label className="form-label">
              Project Name <span className="required">*</span>
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="My Awesome Project"
              className="form-input"
              autoFocus
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              Description
            </label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Describe your project..."
              rows={3}
              className="form-textarea"
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              Project Type
            </label>
            <select
              value={type}
              onChange={(e) => setType(e.target.value)}
              className="form-select"
            >
              <option value="workflow">Workflow</option>
              <option value="api_integration">API Integration</option>
              <option value="cross_subject">Cross-Subject</option>
            </select>
          </div>
        </div>

        {/* Actions */}
        <div className="dialog-actions">
          <button
            onClick={onCancel}
            className="dialog-button cancel"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="dialog-button primary"
          >
            Create Project
          </button>
        </div>
      </div>
    </div>
  );
}

CreateProjectDialog.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

